// 判断是否是最后一条数据，原来判断要不要重新请求的时候翻页
/**
 *
 * @param totalT 总条数
 * @param pagesizeT 每页条数
 * @param currentIndexT 当前的数值
 */
export function needInitQueryFun(totalT,pagesizeT,currentIndexT){
    const total = totalT-0
    const currentIndex = currentIndexT-0
    const pagesize = pagesizeT - 0
    const currentPage = Math.ceil(currentIndex/pagesize) // 当前所在页码
    const totalPage =Math.ceil( (total-1)/pagesize ) // 删除一条后还存在的页码
    if(totalPage<currentPage){ // 如果当前的页面不在剩余的页码之内
        return true // 更新
    }else{
        return false // 不更新
    }
}


